import React from 'react'

import VaultPaymentMethodImg from './assets/vault-payment-methods.png'
import ThreeDsImg from './assets/threeds.png'
import CustomizeUniversalCheckougImg from './assets/customize-universal-checkout.png'

import AlipayLogo from 'assets/svg/landing/logos/alipay.svg'
import AmexLogo from 'assets/svg/landing/logos/amex.svg'
import ApplePayLogo from 'assets/svg/landing/logos/apple-pay.svg'
import AtomeLogo from 'assets/svg/landing/logos/atome.svg'
import BancontactLogo from 'assets/svg/landing/logos/bancontact.svg'
import BlikLogo from 'assets/svg/landing/logos/blik.svg'
import ClearpayLogo from 'assets/svg/landing/logos/clearpay.svg'
import CoinbaseLogo from 'assets/svg/landing/logos/coinbase.svg'
import GooglePayLogo from 'assets/svg/landing/logos/google-pay.svg'
import IDealLogo from 'assets/svg/landing/logos/ideal.svg'
import KlarnaLogo from 'assets/svg/landing/logos/klarna.svg'
import MastercardLogo from 'assets/svg/landing/logos/mastercard.svg'
import OpennodeLogo from 'assets/svg/landing/logos/opennode.svg'
import PayconiqLogo from 'assets/svg/landing/logos/payconiq.svg'
import PaypalLogo from 'assets/svg/landing/logos/paypal.svg'
import VippsLogo from 'assets/svg/landing/logos/vipps.svg'
import VisaLogo from 'assets/svg/landing/logos/visa.svg'

export const featureGuides = [
	{
		title: 'Vault payment methods',
		description: 'Securely store your customers’ payment methods securely.',
		link: './save-payment-methods',
		imgSrc: VaultPaymentMethodImg,
	},

	{
		title: 'Trigger 3DS challenges',
		description: 'Authenticate online payments using an extra layer of security for customers.',
		link: './3ds',
		imgSrc: ThreeDsImg,
	},

	{
		title: 'Customize Universal Checkout',
		description: 'Style our drop-in checkout to blend seamlessly in with your website or mobile app.',
		link: './drop-in/customize',
		imgSrc: CustomizeUniversalCheckougImg,
	},
]

export const integrationDifferencesTable = [
	{
		dropIn: 'Easy to integrate with minimal front-end work',
		headless: 'More development work required',
	},
	{
		dropIn: 'Customization limited to branding',
		headless: 'Full control over the UX and UI',
	},

	{
		dropIn: 'Web, iOS, Android, React Native',
		headless: 'Web, iOS, Android, React Native',
	},

	{
		dropIn: 'PCI-L1 compliant',
		headless: 'PCI-L1 compliant',
	},
]

export const paymentMethods = [
	{
		name: 'Google Pay',
		logo: <GooglePayLogo />,
	},
	{
		name: 'Klarna',
		logo: <KlarnaLogo />,
	},
	{
		name: 'PayPal',
		logo: <PaypalLogo />,
	},
	{
		name: 'Mastercard',
		logo: <MastercardLogo />,
	},
	{
		name: 'Coinbase',
		logo: <CoinbaseLogo />,
	},
	{
		name: 'iDeal',
		logo: <IDealLogo />,
	},
	{
		name: 'Bancontact',
		logo: <BancontactLogo />,
	},
	{
		name: 'Apple Pay',
		logo: <ApplePayLogo />,
	},
	{
		name: 'Alipay',
		logo: <AlipayLogo />,
	},
	{
		name: 'OpenNode',
		logo: <OpennodeLogo />,
	},

	{
		name: 'Amex',
		logo: <AmexLogo />,
	},
	{
		name: 'Atome',
		logo: <AtomeLogo />,
	},
	{
		name: 'Blik',
		logo: <BlikLogo />,
	},
	{
		name: 'Clearpay',
		logo: <ClearpayLogo />,
	},
	{
		name: 'Payconiq',
		logo: <PayconiqLogo />,
	},

	{
		name: 'Visa',
		logo: <VisaLogo />,
	},

	{
		name: 'Vipps',
		logo: <VippsLogo />,
	},
]
